import React from "react";
import "./styles.css";
import { iconStylesMapping } from "./iconStylesMapping";

const Icon = ({
    name,
    style,
    height,
    width,
    size,
    className,
    showTitle = true,
    image,
    ...props
}) => {
    const _style = { ...iconStylesMapping[name], ...style };
    if (size) {
        _style.height = size;
        _style.width = size;
    }
    if (height) {
        _style.height = height;
    }
    if (width) {
        _style.width = width;
    }
    return (
        <img
            title={showTitle ? `icono ${name}` : null}
            className={className}
            src={image}
            alt={`icon-${name}`}
            {...props}
            style={_style}
        />
    );
};

export default Icon;
